import { TreeGrid, VirtualScroll as TreeGridVirtualScroll } from '@syncfusion/ej2-treegrid';
/**
 * Gantt Virtual Scroll module will handle Virtualization
 *
 * @hidden
 */
export class VirtualScroll {
    constructor(parent) {
        this.parent = parent;
        this.bindTreeGridProperties();
    }
    /**
     * Get module name
     *
     * @returns {void} .
     */
    getModuleName() {
        return 'virtualScroll';
    }
    /**
     * Bind virtual-scroll related properties from Gantt to TreeGrid
     *
     * @returns {void} .
     */
    bindTreeGridProperties() {
        this.parent.treeGrid.enableVirtualization = this.parent.enableVirtualization;
        TreeGrid.Inject(TreeGridVirtualScroll);
    }
    /**
     * @returns {number} .
     * @private
     */
    getTopPosition() {
        const virtualTable = this.parent.ganttChartModule.scrollElement.querySelector('.e-virtualtable');
        let transform = virtualTable.style.transform;
        transform = this.parent['normalizeTranslate'](transform);
        const translates = transform.split(',');
        let top;
        if (translates.length > 1) {
            top = translates[1].trim().split(')')[0];
        }
        else {
            const transformString = virtualTable.style.transform;
            top = transformString.substring(transformString.lastIndexOf('(') + 1, transformString.lastIndexOf(')'));
        }
        return parseFloat(top);
    }
    /**
     * To destroy the virtual scroll module.
     *
     * @returns {void} .
     * @private
     */
    destroy() {
        // destroy module
    }
}
